module.exports = __webpack_public_path__ + "img/food5.b4fd6416.jpg";